<template>
  <div class="flex items-center justify-center px-4 lg:px-8">
    <i18n-t
      v-if="hideProviderLogo"
      :keypath="title ?? t('page-title')"
      tag="span"
    />
    <ViewTitle
      v-else
      :provider-key="providerKey ?? undefined"
      :title="title ?? t('page-title')"
      vertical="elective_medical"
    />
  </div>
</template>
<script setup lang="ts">
  import { ViewTitle } from "@versatile-credit-apply/components"
  import {
    useCurrentStaticProviderKey,
    useProviderI18n,
  } from "@versatile-credit-apply/sdk"
  import { computed } from "vue"
  import { type ProviderKey } from "@versatile-credit-apply/omni-apply-client"

  type Props = {
    hideProviderLogo?: boolean
    providerKey?: ProviderKey
    title?: string
  }

  const props = defineProps<Props>()

  const currentProviderKey = useCurrentStaticProviderKey()
  const providerKey = computed(
    () => props.providerKey ?? currentProviderKey.value
  )

  const { t } = useProviderI18n(providerKey)
</script>
